/* ============================================================
   NORTHSHEEP — Mobile sticky Add to Cart bar
   - Shows below 990px once the main product Add-to-cart button is
     scrolled out of view (IntersectionObserver, scroll fallback).
   - Triggers the ORIGINAL product-form button (preserves Dawn ajax /
     cart drawer). No separate form, no separate variant picker.
   - Mirrors the selected variant's price, availability and button
     label/state from the main product form (MutationObserver + events).
   ============================================================ */
(function () {
  if (window.__nsStickyAtcLoaded) return;
  window.__nsStickyAtcLoaded = true;

  function findMainAtc() {
    // The main product Add-to-cart lives inside [id^="ProductInfo-"] and carries
    // id="ProductSubmitButton-…". Card quick-adds use .quick-add__submit, so we
    // explicitly skip anything inside a card / quick-add / modal.
    var info = document.querySelector('[id^="ProductInfo-"]');
    if (info) {
      var b = info.querySelector('[id^="ProductSubmitButton-"], button[name="add"], .product-form__submit');
      if (b) return b;
    }
    var all = document.querySelectorAll('product-form button[name="add"], product-form .product-form__submit');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!el.closest('quick-add-modal') && !el.closest('.card-wrapper') && !el.closest('.quick-add')) {
        return el;
      }
    }
    return all[0] || null;
  }

  function readPrice(priceEl) {
    if (!priceEl) return null;
    // On sale: the sale price is .price-item--sale (visible). Otherwise the
    // regular price. offsetParent !== null filters out the hidden copy.
    var sale = priceEl.querySelector('.price-item--sale');
    if (sale && sale.offsetParent !== null && sale.textContent.trim()) {
      return sale.textContent.trim();
    }
    var reg =
      priceEl.querySelector('.price__regular .price-item--regular') ||
      priceEl.querySelector('.price-item--regular');
    if (reg && reg.textContent.trim()) return reg.textContent.trim();
    var fallback = priceEl.textContent.replace(/\s+/g, ' ').trim();
    return fallback || null;
  }

  function init() {
    var bar = document.querySelector('[data-ns-sticky-atc]');
    if (!bar) return; // not a product page (or feature disabled) -> nothing to do

    var origBtn = findMainAtc();
    if (!origBtn) return; // no main Add-to-cart -> keep the bar hidden

    var stickyBtn = bar.querySelector('[data-ns-sticky-add]');
    var stickyLabel = bar.querySelector('[data-ns-sticky-label]');
    var stickyPrice = bar.querySelector('[data-ns-sticky-price]');
    var stickyVendor = bar.querySelector('[data-ns-sticky-vendor]');
    var addLabel = bar.getAttribute('data-add-label') || 'Add to cart';
    var soldOutLabel = bar.getAttribute('data-soldout-label') || 'Sold out';
    var priceEl =
      document.querySelector('[id^="ProductInfo-"] [id^="price-"]') ||
      document.querySelector('[id^="price-"]');

    // Multi-variant: map of variant id -> size/option label, plus the main
    // form's variant id input, so the vendor/size line follows the selection.
    var variantMap = null;
    var mapEl = bar.querySelector('[data-ns-sticky-variants]');
    if (mapEl) {
      try {
        variantMap = JSON.parse(mapEl.textContent);
      } catch (e) {
        variantMap = null;
      }
    }
    var origForm = origBtn.closest('form');
    var variantIdInput =
      (origForm && origForm.querySelector('[name="id"]')) ||
      document.querySelector('[id^="ProductInfo-"] [name="id"]');

    function updateVendor() {
      if (!variantMap || !stickyVendor || !variantIdInput) return;
      var id = (variantIdInput.value || '').toString();
      if (id && variantMap[id]) stickyVendor.textContent = variantMap[id];
    }

    var mq = window.matchMedia('(max-width: 989px)');
    var origVisible = true;
    /* Starts false: on load the button is normally BELOW the fold, which is
       not the same as having been passed. Without this the bar flashed in
       before the shopper had scrolled anywhere. */
    var origPassed = false;

    function sync() {
      var disabled = origBtn.disabled || origBtn.getAttribute('aria-disabled') === 'true';
      if (stickyBtn) stickyBtn.disabled = disabled;

      // "Added" state (ns-card-cart-state.js): the cart already holds all of
      // this variant's stock. Mirror the main button's wording and colour; a
      // tap still clicks the main button, which then opens the cart.
      var maxed = origBtn.classList.contains('is-maxed');
      if (stickyBtn) stickyBtn.classList.toggle('is-maxed', maxed && !disabled);

      if (stickyLabel) {
        if (disabled || maxed) {
          // mirror the main button text (Sold out / Unavailable / Added to cart …)
          var span = origBtn.querySelector('span');
          var txt = (span ? span.textContent : origBtn.textContent || '').trim();
          stickyLabel.textContent = txt || (disabled ? soldOutLabel : addLabel);
        } else {
          stickyLabel.textContent = addLabel;
        }
      }

      if (stickyPrice && priceEl) {
        var p = readPrice(priceEl);
        if (p) stickyPrice.textContent = p;
      }

      updateVendor();
    }

    /* SHOWN ONLY AFTER THE REAL BUTTON HAS BEEN PASSED.

       It used to appear whenever the button was off screen, which includes
       the whole way down the gallery — before the shopper had been offered
       the decision at all. On a long product page that meant a persistent
       bar arguing for a purchase nobody had reached yet, costing screen
       height on the device with least of it.

       The bar's job is to bring back a control that has scrolled AWAY. So it
       needs two facts, not one: the button is not on screen, and it is above
       the viewport rather than still below it. */
    function update() {
      if (!mq.matches) {
        bar.classList.remove('is-visible');
        return;
      }
      if (!origVisible && origPassed) {
        // ensure a frame exists before adding the class so the slide animates
        window.requestAnimationFrame(function () {
          if (mq.matches && !origVisible) bar.classList.add('is-visible');
        });
      } else {
        bar.classList.remove('is-visible');
      }
    }

    // ---- Scroll visibility -------------------------------------------------
    /* ONE function decides, from the button's own rectangle.

       Two facts, because the bar needs both: is the button on screen, and has
       it been scrolled PAST. Off screen alone is not enough — the whole way
       down the gallery the button is off screen too, and showing the bar
       there argues for a decision the shopper has not been offered yet.

       The 80px discount is the bar's own footprint: a button hidden behind
       the bar is not really on screen. */
    /* THE FOOTER ENDS ITS SHIFT (owner, 20 Sep 2026: "maybe we shouldnt show
       the floating add to cart all the way till the bodem because now you can
       not see the legal pages").

       Pinned to the bottom of every screen, the bar covered the footer's last
       row — which is where Terms, Privacy, Shipping and Returns live. Those
       links have to be reachable from every page, so a control that sits on
       top of them forever is not a design preference, it is a link the
       shopper cannot click.

       It is also the right call for the bar itself: someone reading the
       footer has stopped shopping this hide. The bar steps aside as soon as
       the footer reaches the bottom of the screen, and comes straight back
       when they scroll up into the page again. */
    /* THE WHOLE FOOTER, not just its legal row (owner, 20 Sep 2026: "can you
       hide the floating add to cart as soon as people reach the footer so it
       doesnt interfere with the important information down the bottom").

       This was narrowed to the bottom row for a moment, on the argument that
       a shopper reading the newsletter block might still want to add the
       hide. The owner's call is the better one: the footer is not a place
       anyone is shopping from, everything in it — contact, shipping, returns,
       the legal links — is there to be READ, and a control parked over it
       competes with all of it rather than with one row.

       So the bar stands down as the footer reaches the bottom of the screen
       and returns the moment the page is scrolled back up. */
    var footer = document.querySelector('.footer, #shopify-section-footer, footer');

    function footerInView() {
      if (!footer) return false;
      var f = footer.getBoundingClientRect();
      return f.top < window.innerHeight;
    }

    function measure() {
      var r = origBtn.getBoundingClientRect();
      origVisible = r.bottom > 0 && r.top < window.innerHeight - 80;
      origPassed = r.bottom <= 0 && !footerInView();
      update();
    }

    /* Scroll drives it, throttled to one measurement per frame. An
       IntersectionObserver alone was not enough in practice: it reports only
       at threshold crossings, so a page restored mid-scroll (a reload at
       position, a back-navigation) could sit below the button with the bar
       never told. One rect read per frame on a single element is cheap, and
       the behaviour is the same everywhere instead of depending on when the
       observer last fired. */
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        measure();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();

    // ---- Keep price / availability / label in sync -------------------------
    /* In a function because they have to be pointed at the NEW button and
       price after a colour swap; an observer watching a node that has been
       removed from the document reports nothing, for ever, in silence. */
    var moBtn = null;
    var moPrice = null;

    function observeMain() {
      if (!('MutationObserver' in window)) return;
      if (moBtn) moBtn.disconnect();
      if (moPrice) moPrice.disconnect();
      moBtn = new MutationObserver(sync);
      moBtn.observe(origBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
      if (priceEl) {
        moPrice = new MutationObserver(sync);
        moPrice.observe(priceEl, { childList: true, subtree: true, characterData: true });
      }
    }
    observeMain();

    /* A COLOUR SWAP IS A NEW PRODUCT WITHOUT A PAGE LOAD.

       ns-colour-siblings.js replaces the product section and refreshes this
       bar's markup, then fires this. Everything below was captured when the
       page loaded and now points at detached nodes — the button whose state
       this mirrors, the price it reads, the variant input it follows, and the
       bar's own children. All of it is re-read here.

       The window and document listeners are NOT re-bound: they are attached
       once, to nodes the swap cannot replace. */
    document.addEventListener('ns:colour-swapped', function () {
      var nextBtn = findMainAtc();
      if (!nextBtn) return;
      origBtn = nextBtn;
      origForm = origBtn.closest('form');
      priceEl =
        document.querySelector('[id^="ProductInfo-"] [id^="price-"]') ||
        document.querySelector('[id^="price-"]');
      variantIdInput =
        (origForm && origForm.querySelector('[name="id"]')) ||
        document.querySelector('[id^="ProductInfo-"] [name="id"]');

      stickyBtn = bar.querySelector('[data-ns-sticky-add]');
      stickyLabel = bar.querySelector('[data-ns-sticky-label]');
      stickyPrice = bar.querySelector('[data-ns-sticky-price]');
      stickyVendor = bar.querySelector('[data-ns-sticky-vendor]');

      /* The size map belongs to the product, so it comes back with the new
         bar. Without this the line under the title would keep offering the
         previous product's sizes. */
      variantMap = null;
      var nextMap = bar.querySelector('[data-ns-sticky-variants]');
      if (nextMap) {
        try {
          variantMap = JSON.parse(nextMap.textContent);
        } catch (e) {
          variantMap = null;
        }
      }

      observeMain();
      sync();
      measure();
    });
    // Variant pickers (selects / radios) — re-sync shortly after a change so the
    // main form has finished updating.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.setTimeout(sync, 60);
      }
    });

    // ---- Click-through: trigger the ORIGINAL Add-to-cart -------------------
    /* Delegated to the BAR, not bound to the button inside it. The colour
       selector replaces the bar's contents on a swap, which would take a
       button-bound listener with it and leave a control that does nothing. */
    bar.addEventListener('click', function (event) {
      var hit = event.target.closest && event.target.closest('[data-ns-sticky-add]');
      if (!hit) return;
      if (hit.disabled || origBtn.disabled) return;
      origBtn.click(); // submits the existing product form -> Dawn ajax / drawer
    });

    // ---- Breakpoint + resize ----------------------------------------------
    var onMq = function () {
      update();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
    window.addEventListener('resize', update, { passive: true });

    sync();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
